"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(3),
  padding: theme.spacing(0, 3, 3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 4, 3)
  }
}));
//# sourceMappingURL=styles.js.map